import { useState } from 'react';
import InputForm from '../../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import DataType from '../../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress, Grid } from '@mui/material';
import SearchInput from '../../../SearchInput';
import SearchModal from '../../../SearchModal';
import {  AttachMoneyOutlined,AdminPanelSettingsOutlined } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import Data from '../../../../Data/Data.json';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import SelectOption from '../../../SelectOption';
import DataSelect from '../../../../Types/DataSelect';
let Link = require('../../../../Data/Data.json');


const dataOption2: DataSelect[] = [
  { label: "D--DEBIT", value: "D" },
  { label: "C--CREDIT", value: "C" }
]


const Tab1 = (props: { etatG: boolean,dissablelibop : boolean , form?: any , consult:Function}) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Filtre, setFiltre] = useState<number>();
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const authHeader = useAuthHeader();


  //Initialisation des parametres de recherche
  let searchRef: ParamsPicklist = { CodeAgence: '', Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
  let searchOp: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
  let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "101", Choix: 22 }


  let informationclient = {
    SearchRef: {
      Titre: "Recherche Service",
      label: "Réference",
      name: "Reference", params: searchRef
    },
    searchCodeOpe: {
      Titre: "Recherche Opération",
      label: "Opération",
      name: "CodeOpe", params: searchOp
    },
    searchCompte: {
      Titre: "Recherche Compte  ",
      label: "Compte",
      name: "NUMCPT", params: searchCompte
    },
    //Montant disponible du compte à débité
    InputDisponible: {
      label: "Disponible",
      name: "DISPON"
    },
    //Montant disponible pour le recepteur
    InputBloque: {
      label: "Montant Bloqué",
      name: "BLOQUE"
    },
    InputAutori: {
      label: "Autorisation",
      name: "AUTORI"
    },
    //Montant disponible pour le recepteur
    InputVeille: {
      label: "Solde Veille",
      name: "SOLVEI"
    },
    InputTaux: {
      label: "Taux",
      name: "Taux"
    },
    InputMontant: {
      label: "Montant",
      name: "Montant"
    },
    InputNumPiece: {
      label: "N° Pièce",
      name: "Montant"
    }
  }



  const handleChangeCompte = async () => {

    setLoading(true);
    let NUMCPT = '';
    NUMCPT = props.form.getFieldValue('NUMCPT');

    let data = Crypter.encrypt(NUMCPT);

    props.form.setFieldsValue({ "lib_NUMCPT": '', 'DISPON': '', 'BLOQUE': '', 'SOLVEI': '','AUTORI':'','CDDEVS':'','lib_CDDEVS':'' })

    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetCompte,
      headers: {
        'CypherNumCpte': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Link.ApiUrl.GetGetCodeOperat,
      headers: {
        'CypherChampOpe': Crypter.encrypt('OPE009'),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let requestOne = axios.request(config1);
    let requestTwo = axios.request(config2);

    await axios
      .all([requestOne, requestTwo])
      .then(
        await axios.spread(async (...responses: any) => {

          const responseOne = responses[0];
          const responseTwo = responses[1];
          if (responseOne.data) {
            const res = JSON.parse(Crypter.decrypt(responseOne.data));
            if (res.StatutCode == 200) {
              let datas = res.Result.Table[0];

              if (res.Result.Table.length > 0) {
                props.form.setFieldsValue({ 'lib_NUMCPT': datas.NOMCPT, 'DISPON': formatNumber(datas.DISPON), 'CDDEVS': datas.CDDEVS, 'lib_CDDEVS': datas.CDDEVS, 'SOLVEI': datas.SOLVEI, 'BLOQUE': datas.BLOQUE, 'AUTORI': datas.AUTORI });
                //Devise
              } else {
                SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
              }

              if (responseTwo.data) {
                const res = JSON.parse(Crypter.decrypt(responseTwo.data)).Value;
                if (res.StatutCode == 200) {
                  let datas = res.Result[0];
                  props.form.setFieldValue("Libelle", datas.LIBELL + ' FAVEUR ' + props.form.getFieldValue("lib_NUMCPT"))
                }
                else {
                  setLoading(false);
                  SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                }
              }
            }
            else {
              setLoading(false);
              SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
            }
          }
        }
        )).catch((errors) => {
          SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
        });
    setLoading(false);
  }



  return (
    <div className='tabItem' >
      <div >
        <Box fontStyle="inherit" className='bordure1' width={"85%"} position={"absolute"}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
                <SearchInput notremove handleFunction={props.consult} dissabledCode={props.etatG} dissabledLib={true} width={5} Titre={informationclient.SearchRef.Titre} label={informationclient.SearchRef.label} name={informationclient.SearchRef.name} Parametre={informationclient.SearchRef.params} form={props.form} />
             </Grid>
            <Grid item xs={8} >
                <SearchInput notRequired form={props.form} dissabledLib={props.dissablelibop} Taille2={'30em'} dissabledCode={true} Titre={informationclient.searchCodeOpe.Titre} label={informationclient.searchCodeOpe.label} name={informationclient.searchCodeOpe.name} Parametre={informationclient.searchCodeOpe.params} />
            </Grid>
          </Grid>
          <Grid container spacing={0} >
            <Grid item xs={4}>
                <SearchModal disabled notRequired width={5} handleFunction={handleChangeCompte} form={props.form} Titre={informationclient.searchCompte.Titre} label={informationclient.searchCompte.label} name={informationclient.searchCompte.name} Parametre={informationclient.searchCompte.params} />
                <SelectOption notRequired disabled Option={dataOption2} width={5} label='Sens' Size={'middle'} name="Sence" />
            </Grid>

            <Grid item xs={4}>
                <SearchModal width={6} notRequired form={props.form} disabled Titre="Recherche devise" label={"Devise"} name="CDDEVS" Parametre={informationclient.searchCompte.params} />
                <InputForm width={6} money disabled notRequired icon={<AttachMoneyOutlined />} label={informationclient.InputMontant.label} name={informationclient.InputMontant.name} type='text' />
            </Grid>

            <Grid item xs={4}>
                <InputForm disabled notRequired icon={<AdminPanelSettingsOutlined />} defaultValue={1} width={7} label={informationclient.InputTaux.label} name={informationclient.InputTaux.label} type='number' />
                <InputForm disabled notRequired label="Reférence " width={7} name='RefManuel' type='text' />
         
            </Grid>


          </Grid>
          <Box>
          </Box>
        </Box>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
export default Tab1;
